import { render } from "./ExportPage.vue?vue&type=template&id=52a7524f&scoped=true&ts=true"
import script from "./ExportPage.vue?vue&type=script&lang=ts"
export * from "./ExportPage.vue?vue&type=script&lang=ts"

import "./ExportPage.vue?vue&type=style&index=0&id=52a7524f&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a7524f"]])

export default __exports__